import posthog from 'posthog-js'
import { call, put, takeLatest } from 'redux-saga/effects'
import { FETCH_USER_DATA, SIGN_OUT, SIGN_OUT_FAIL, SIGN_OUT_SUCCESS } from 'dealer-reducers'
import apiCall from '../helpers/apiCall'
import { POST } from '../consts/methods'
import { isPosthogReady } from '../helpers/posthog'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* SignOutFlow(): Generator<any, void, any> {
  try {
    const endpoint = '/dealers/auth/sign_out'
    yield call(apiCall, { endpoint, method: POST, params: {} })
    yield put(SIGN_OUT_SUCCESS())
    if (isPosthogReady()) {
      posthog.reset()
    }
    localStorage.clear()
    yield put(FETCH_USER_DATA())
  } catch (error) {
    yield put(SIGN_OUT_FAIL())
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* SignOut(): Generator<any, void, any> {
  yield takeLatest(SIGN_OUT, SignOutFlow)
}
